import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'
import { BreadcrumbItem, Breadcrumbs, Tab, Tabs, Spacer, Badge } from '@nextui-org/react'
import api from 'src/lib/api'
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import AccountSetting from './account-setting'
import BillingSetting from './billing-setting'
import CompanyDetails from 'src/pages/settings/company-details'
import { useWorkspaceContextData } from 'src/context/workspace'
import PowerdocsCustomize from 'src/pages/settings/powerdocs-customize'
import { Icon } from '@iconify/react'
import CompanyInfo from '../admin/components/company-info'
import CompanyLegal from '../admin/components/company-legal'
import CompanyFinancial from '../admin/components/company-financial'
import CompanyHR from '../admin/components/company-hr'
import CompanyTechnicalCapabilities from '../admin/components/company-technical'
import CompanyReferences from '../admin/components/company-references'
import CompanyTenderExperience from '../admin/components/company-tenders-experience'

export default function Settings() {
  const { t } = useTranslation()

  const [profile, setPorfile] = useState<any>({})
  const loadUser = () => {
    const userString = localStorage.getItem('user')
    if (userString) {
      setPorfile(JSON.parse(userString))
    }
    api
      .get('/agencies/profile')
      .then((res) => {
        localStorage.setItem('user', JSON.stringify(res.data))
        setPorfile(res.data)
      })
      .catch((e) => {
        console.log('Error loading current profile')
      })
  }
  useEffect(() => {
    loadUser()
  }, [])

  const { tab } = useParams()
  const [selected, setSelected] = React.useState(tab)
  const [selectedCompanyKey, setSelectedCompanyKey] = React.useState('general-info')
  const [workspace, setWorkspace] = useState(null)
  const { activeWorkspace } = useWorkspaceContextData()
  useEffect(() => {
    if (profile && activeWorkspace) {
      const ws = (profile.workspaces || []).filter((w: {uuid: string}) => w.uuid === activeWorkspace).pop()
      if (ws) setWorkspace(ws)
    }
  }, [profile, activeWorkspace])
  const navigate = useNavigate()
  const tabs = {
    profile: 'Profile',
    company: 'Company details',
    powerdocs: 'Personalize Powerdocs AI',
    billing: 'Billing details',
  }
  return (
    <>
      <Helmet>
        <title>{t('title')}</title>
      </Helmet>
      <div className="flex flex-col w-full h-screen p-3 overflow-y-auto">
        
        <Breadcrumbs className={'pl-2 pt-4'}>
          <BreadcrumbItem onClick={() => navigate('/')}>
            <Icon icon={'lucide:home'} /> Home
          </BreadcrumbItem>
          <BreadcrumbItem onClick={() => navigate('/settings')}>Settings</BreadcrumbItem>
          <BreadcrumbItem>{tabs[selected as keyof typeof tabs] || 'Settings'}</BreadcrumbItem>
        </Breadcrumbs>

        {/*  Tabs */}
        <div className="flex flex-col gap-3 w-full h-full px-2 2xl:px-8 max-w-[80vw]">
          <Tabs
            fullWidth
            aria-label="Settings"
            selectedKey={selected}
            onSelectionChange={(key: string|number) => {
              setSelected(key as string)
              navigate(`/settings/${key}`)
            }}
            classNames={{
              base: 'mt-6',
              cursor: 'bg-content1 dark:bg-content1',
              panel: 'w-full p-0 pt-1',
            }}
          >
            <Tab key="profile" title="Profile">
              <AccountSetting className="pb-20" />
            </Tab>
            <Tab key="company" title={<span>Company details</span>}>
              <CompanyDetails
                workspace={workspace}
                setWorkspace={setWorkspace}
                profile={profile}
                loadUser={loadUser}
                className="pb-20"
              />
            </Tab>
            <Tab key="powerdocs" title={<span>Personalize Powerdocs AI</span>}>
              <PowerdocsCustomize
                workspace={workspace}
                setWorkspace={setWorkspace}
                profile={profile}
                loadUser={loadUser}
                className="pb-20"
              />
            </Tab>
            {/* <Tab key="appearance" title="Appearance">
              <AppearanceSetting />
            </Tab> */}
            <Tab key="billing" title="Billing details">
              <BillingSetting client={profile} loadUser={loadUser} className="pb-20" hideBillingAddress={true} />
            </Tab>
          </Tabs>
        </div>

        <Spacer y={20} />
      </div>
    </>
  )
}
